import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Base } from "../framework/base";

interface FormSummaryState {
    dateRange: [string, string];
    relatedObjectType: string;
    relatedObjectIds: string[];
    formTemplateIds: string[];
    answeredByEmployeeIds: string[];
}

const getDefaultDateRange = (): [string, string] => [
    Base.dayjsToJsonDate(Base.dateAddDays(new Date(), -30)),
    Base.dayjsToJsonDate(new Date()),
];

export const initialState: FormSummaryState = {
    dateRange: getDefaultDateRange(),
    relatedObjectType: "",
    relatedObjectIds: [],
    formTemplateIds: [],
    answeredByEmployeeIds: [],
};

export const formSummarySlice = createSlice({
    name: "formSummary",
    initialState,
    reducers: {
        setDateRange(state, action: PayloadAction<[string, string]>) {
            state.dateRange = action.payload;
        },
        setRelatedObjectType(state, action: PayloadAction<string>) {
            state.relatedObjectType = action.payload;
            state.relatedObjectIds = [];
        },
        setRelatedObjectIds(state, action: PayloadAction<string[]>) {
            state.relatedObjectIds = action.payload;
        },
        setFormTemplateIds(state, action: PayloadAction<string[]>) {
            state.formTemplateIds = action.payload;
        },
        setAnsweredByEmployeeIds(state, action: PayloadAction<string[]>) {
            state.answeredByEmployeeIds = action.payload;
        },
        resetFilters() {
            return {
                ...initialState,
                dateRange: getDefaultDateRange(),
            };
        },
    },
});

export const {
    setDateRange,
    setRelatedObjectType,
    setRelatedObjectIds,
    setFormTemplateIds,
    setAnsweredByEmployeeIds,
    resetFilters,
} = formSummarySlice.actions;
export const formSummaryReducer = formSummarySlice.reducer;
